export const blockIconsHardwareDeveloperModeNew = (
	<span className='material-symbols-outlined'>developer_mode</span>
);
